<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :lock-scroll="false" :before-close="handleClose">
    <div class="offerhistorydialog" v-loading="loading">
      <ul v-if="detail!=null">
        <li>
          <span>{{$t('base.myPrice')}}</span>
          <span>{{areaSymbol}} {{detail.USD_Price}}</span>
        </li>
        <li>
          <span>{{$t('base.minOfferAmount')}}</span>
          <span>{{areaSymbol}} {{detail.USD_LPrice}}</span>
        </li>
        <li>
          <span>{{$t('base.autoAcceptOffer')}}</span>
          <span>{{areaSymbol}} {{detail.USD_HPrice}}</span>
        </li>
      </ul>
      <div v-if="offerList!=null">
        <div class="offerListdialog offerdialogTitle">
          <div>{{$t('base.offerFrom')}}</div>
          <div>{{$t('base.offerPrice')}}</div>
          <div>{{$t('base.time')}}</div>
        </div>
        <el-scrollbar>
          <div class="offerscrollbar">
            <div v-for="(item,index) in offerList" :key="index" class="offerListdialog">
              <div><span :class="item.RealName!='Me'&&item.MemberSource!=userInfo.MemberSource?'earth '+item.MemberSource:''">{{item.RealName}}</span></div>
              <div>{{areaSymbol}} {{item.US_Price}}</div>
              <div>{{item.Createdate|setTime}}</div>
            </div>
          </div>
        </el-scrollbar>
        <div class="offerListdialogBtn">
          <el-button type="primary" @click="handleClose">{{$t('base.done')}}</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { getTime } from "@/api/public";
export default {
  name: '',
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      loading: false,
      detail: null,
      offerList: null
    }
  },
  props: {
    dialogClass: '',
    title: "",
    domVisible: Boolean,
    list: {},
    viewList: {},
    userInfo: {}
  },
  filters: {
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
  },
  watch: {},
  created() {
    this.getDetail()
    this.getBargain()
  },
  methods: {
    handleClose() {
      this.$emit('closeDialog', 'offerhistory', false)
    },

    getDetail() {
      this.loading = true
      let that = this;
      let data = { 'memberid': '', 'CommodityID': this.list.RelationID }
      if (that.userInfo != null) {
        data = { 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId, 'CommodityID': this.list.RelationID }
      }
      that.$get(that.$interface.DetailCommodity, data).then(res => {
        if (res.result != 0) {
          let result = res.data
          that.detail = result;
        }
        that.loading = false
      })
    },
    getBargain() {
      let that = this;
      let data = { 'memberid': '', 'CommodityID': this.list.RelationID }
      if (that.userInfo != null) {
        data = { 'memberid': this.list.CreateUser, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId, 'CommodityID': this.list.RelationID }
      }
      that.$get(that.$interface.BargainList, data).then(res => {
        if (res.result != 0) {
          let result = res.data;
          result.map(r => {
            if (r.RealName == that.userInfo.NickName) {
              r.RealName = 'Me'
            }
          })
          that.offerList = result
        }
      })
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.offerhistorydialog {}

.offerhistorydialog ul {
  margin-bottom: 20px;
}

.offerhistorydialog ul li {
  line-height: 1.5;
  font-size: 14px;
}

.offerhistorydialog ul li span:last-child {
  margin-left: 12px;
}

.offerhistorydialog dl {
  width: 100%;
}

.offerhistorydialog .offerListdialog {
  align-items: center;
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  min-height: 30px;
  padding: 0 10px;
  box-sizing: border-box;
}

.offerscrollbar {
  max-height: 150px;
}

.offerhistorydialog .offerdialogTitle {
  background-color: #f7f7f7;
}

.offerhistorydialog .offerListdialog>div {
  width: 35%;
}

.offerhistorydialog .offerListdialog div:last-child,
  {
  width: 30%;
}

.offerhistorydialog .offerListdialog div span.earth {
  padding: 0 26px 0 0;
  background: url(/static/images/icon/icon_earth.svg) no-repeat 100% 50%;
}

.offerListdialogBtn {
  text-align: right;
  margin: 50px 0 0;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/offerhistory.vue